import * as React from "react"
import { cn } from "@/lib/utils"

type PageHeaderProps = {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  tabs?: React.ReactNode
  /**
   * When true (default), renders a hairline bottom border under the title +
   * actions row. Set to false when the surrounding section already provides
   * its own visual separator (e.g. a shaded full-bleed header band).
   */
  bordered?: boolean
}

export function PageHeader({
  title,
  description,
  actions,
  tabs,
  bordered = true,
}: PageHeaderProps) {
  return (
    <div>
      <div
        className={cn(
          "flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between",
          bordered && "border-b border-hairline pb-6",
        )}
      >
        <div className="min-w-0 flex-1">
          <h1>{title}</h1>
          {description && <p className="mt-1 max-w-lg">{description}</p>}
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
      {tabs}
    </div>
  )
}
